import { useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/client-app/components/ui/dialog';
import { toCssVars, useCssVarsDesignTokenContext } from 'css-vars-design-token';
import { CircleCheck } from 'lucide-react';
import { AvatarProfileLeft } from './TutorAvatar';
import { Text } from './Typography';
import { Trans } from '@lingui/react/macro';
import { useRudderStackAnalytics } from '../hooks/use-analytics';

export const PromoDialog = (props: {
  open: boolean;
  promoKey: string;
  onSuccess(): void;
  onCancel(): void;
}) => {
  const design = useCssVarsDesignTokenContext();
  const css = toCssVars(design.token);
  const analytics = useRudderStackAnalytics();

  useEffect(() => {
    if (analytics && props.open) {
      analytics?.track(
        'Consumer Modal Open',
        {
          app: 'ProfAI',
        }
      );
    }
  }, [analytics, props.open]);

  const trackCta = (cta: string) => {
    analytics?.track(
      'Consumer Modal CTA',
      {
        app: 'ProfAI',
        cta,
      }
    );
  };
  return (
    <Dialog open={props.open}>
      <DialogContent
        mobileFullScreen
        hideCloseButton
        className="flex h-full flex-col p-8 pt-0"
        onOpenAutoFocus={(e) => e.preventDefault()}
      >
        <div style={{ ...css }}>
          <DialogHeader>
            <div
              style={{ height: 200, overflow: 'hidden' }}
              className="flex justify-between items-flex-end bg-warm-5 gap-10 p-8 pb-0 mt-12 rounded-md"
            >
              <DialogTitle>
                <Text header m semiBold>
                  <Trans>
                    Get your whole
                    <br /> team{' '}
                    <Text inline tomato>
                      AI-certified
                    </Text>
                    <br /> with ProfAI for Teams
                  </Trans>
                </Text>
              </DialogTitle>
              <AvatarProfileLeft reverse width={120} />
            </div>
          </DialogHeader>
          <Text xl>
            <ul className="flex flex-col gap-4 py-8">
              <li className="flex gap-2 items-center">
                <CircleCheck className="text-tomato rounded-full" />
                <Trans>Team access for 50+ people</Trans>
              </li>
              <li className="flex gap-2 items-center">
                <CircleCheck className="text-tomato rounded-full" />
                <Trans>Enterprise reporting and analytics</Trans>
              </li>
              <li className="flex gap-2 items-center">
                <CircleCheck className="text-tomato rounded-full" />
                <Trans>Customizable to your policies and priorities</Trans>
              </li>
            </ul>
          </Text>
          <div className="flex flex-col gap-4 mt-auto">
            {/* @ts-expect-error Reference a different build system variable */}
            <a href={import.meta.env.VITE_PROMO_LINK} target="_blank" rel="noopener noreferrer">
              <button className="neo large block w-full" onClick={() => {
                trackCta('Talk to Sales');
                props.onSuccess;
              }}>
                <Trans>Talk to Sales ›</Trans>
              </button>
            </a>
            <button className="neo large tertiary block w-full centered" onClick={props.onCancel}>
              <Text style={{ textTransform: 'uppercase' }}>
                <Trans>Maybe Later</Trans>
              </Text>
            </button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
